import React from "react";
import { Stack } from "@mui/material";
import { HeaderToolbar } from "../components/header-toolbar";

interface WideLayoutProps {
  children: React.ReactNode;
  showNavigation?: boolean;
  lockToViewport?: boolean;
}

const WideLayout = ({
  children,
  showNavigation = true,
  lockToViewport = false,
}: WideLayoutProps) => {

  return (
    <Stack
      justifyContent="top"
      alignItems="center"
      spacing={2}
      sx={{
        minHeight: "100vh",
        height: lockToViewport ? "100vh" : "auto",
        overflow: lockToViewport ? "hidden" : "visible",
        width: "100%",
        backgroundColor: "#F5F5F5",
      }}
    >
      {showNavigation && <HeaderToolbar />}
      <Stack
        sx={{
          width: "100%",
          flex: lockToViewport ? 1 : "initial",
          minHeight: lockToViewport ? 0 : "auto",
          overflow: lockToViewport ? "hidden" : "visible",
          alignItems: "center",
        }}
      >
        {children}
      </Stack>
    </Stack>
  );
};

export default WideLayout;
